export enum MangersActivityReportEnum {
    today = 1,
    last7Days = 7,
    last15Days = 15,
    last30Days = 30,
}